enum ModalType {
    None,
    Login,
    PasswordChange,
}

export default ModalType;
